import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer } from '../styles';
import { getAreaFullName } from '../constants';
import icono from '../imgs/icons/edu_iconos_binoculars.svg';

// const cleanDisciplinesName = fieldName => {
//   return fieldName
//     .replace('perc_A_', '')
//     .replace('perc_B_', '')
//     .replace('perc_C_', '');
// };

function makeCoursesString(courses) {
  const arr = courses.split('\n');
  if (arr.length === 1) return arr[0];
  const firsts = arr.slice(0, arr.length - 1);
  const last = arr[arr.length - 1];
  return firsts.join(', ') + ' y ' + last;
}

const Filosofía = ({ cursos }) => (
  <>
    <p className='justified'>
      Interés en profundizar en grandes temáticas filosóficas, formular
      preguntas significativas a usando conceptos filosóficos o discutir con
      compañeros/as grandes problemas de la filosofía, de la política, o sobre
      conceptos como libertad, justicia o verdad.
    </p>
    <p className='text-center'>
      ¿Qué asignaturas de profundización se relacionan con esta disciplina y te
      podrían atraer más?
    </p>
    <p className='text-center'>
      <strong>
        {cursos
          ? makeCoursesString(cursos)
          : 'Estética, Filosofía Política, Seminario de Filosofía'}
        .
      </strong>
    </p>
  </>
);

const HGCSOC = ({ cursos }) => (
  <>
    <p className='justified'>
      Interés en profundizar en el estudio de la historia, la sociedad y su
      relación con la geografía que habita, así como en analizar problemas
      actuales usando conceptos y teorías de la historia, la geografía y la
      economía.
    </p>
    <p className='text-center'>
      ¿Qué asignaturas de profundización se relacionan con esta disciplina y te
      podrían atraer más?
    </p>
    <p>
      <strong>
        {cursos
          ? makeCoursesString(cursos)
          : 'Comprensión Histórica del Presente, Economía y Sociedad, Geografía, Territorio y Desafíos Socio-ambientales'}
        .
      </strong>
    </p>
  </>
);

const LenguaLiteratura = ({ cursos }) => (
  <>
    <p className='justified'>
      Interés en el estudio del lenguaje, la comunicación y la creación
      literaria, en adquirir técnicas para escribir textos literarios o
      especializados, aprender a desarrollar buenos argumentos o participar en
      debates.
    </p>
    <p className='text-center'>
      ¿Qué asignaturas de profundización se relacionan con esta disciplina y te
      podrían atraer más?
    </p>
    <p className='text-center'>
      <strong>
        {cursos
          ? makeCoursesString(cursos)
          : 'Literatura y Escritura Especializada, Participación y Argumentación en Democracia, Taller de Literatura'}
        .
      </strong>
    </p>
  </>
);

const CienciasBio = ({ cursos }) => (
  <>
    <p className='justified'>
      Interés en profundizar en conocimientos relacionados con la biología, la
      genética, el medioambiente, las ciencias de la salud, o la biotecnología,
      así como adquirir habilidades para el desarrollo de investigaciones
      científicas.
    </p>
    <p className='text-center'>
      ¿Qué asignaturas de profundización se relacionan con esta disciplina y te
      podrían atraer más?
    </p>
    <p className='text-center'>
      <strong>
        {cursos
          ? makeCoursesString(cursos)
          : 'Biología de los Ecosistemas, Biología Celular y Molecular, Ciencias de la Salud'}
        .
      </strong>
    </p>
  </>
);

const CienciasBasicas = ({ cursos }) => (
  <>
    <p className='justified'>
      Interés en profundizar en conocimientos relacionados con la física y/o la
      química, aprender principios de la mecánica, termodinámica, el universo y
      la organización de la naturaleza, así como adquirir habilidades para el
      desarrollo de investigaciones científicas.
    </p>
    <p className='text-center'>
      ¿Qué asignaturas de profundización se relacionan con esta disciplina y te
      podrían atraer más?
    </p>
    <p className='text-center'>
      <strong>
        {cursos ? makeCoursesString(cursos) : 'Química y Física'}.
      </strong>
    </p>
  </>
);

const Matematicas = ({ cursos }) => (
  <>
    <p className='justified'>
      Interés en profundizar en el estudio de las matemáticas, aprendiendo
      conceptos relacionados con el uso de funciones, análisis estadísticos,
      geometría analítica y 3D, así como desarrollar el pensamiento
      computacional, o aprender a trabajar con límites, derivadas o integrales.
    </p>
    <p className='text-center'>
      ¿Qué asignaturas de profundización se relacionan con esta disciplina y te
      podrían atraer más?
    </p>
    <p className='text-center'>
      <strong>
        {cursos
          ? makeCoursesString(cursos)
          : 'Geometría 3D, Límites, Derivadas e Integrales, Pensamiento Computacional y Programación, Probabilidades y Estadística Descriptiva'}
        .
      </strong>
    </p>
  </>
);

const ArtesVisuales = ({ cursos }) => (
  <>
    <p className='justified'>
      Interés en adquirir conocimientos y desarrollar habilidades relacionadas
      con las artes visuales, audiovisuales o multimedia, el diseño o la
      arquitectura, tanto para crear proyectos propios, como para analizar y
      reflexionar sobre proyecto y obras creadas por otros.
    </p>
    <p className='text-center'>
      ¿Qué asignaturas de profundización se relacionan con esta disciplina y te
      podrían atraer más?
    </p>
    <p className='text-center'>
      <strong>
        {cursos
          ? makeCoursesString(cursos)
          : 'Artes Visuales, Audiovisuales y Multimediales, Diseño y Arquitectura'}
        .
      </strong>
    </p>
  </>
);

const ArtesInterpretativas = ({ cursos }) => (
  <>
    <p className='justified'>
      Interés en adquirir técnicas y conocimientos para la interpretación en
      distintas disciplinas artísticas, como la música, el teatro o la danza,
      así como para la creación artística en estas áreas.
    </p>
    <p className='text-center'>
      ¿Qué asignaturas de profundización se relacionan con esta disciplina y te
      podrían atraer más?
    </p>
    <p className='text-center'>
      <strong>
        {cursos
          ? makeCoursesString(cursos)
          : 'Creación y Composición Musical, Interpretación Musical, Interpretación y Creación, Interpretación y Creación en Teatro'}
        .
      </strong>
    </p>
  </>
);

const Deportes = ({ cursos }) => (
  <>
    <p className='justified'>
      Interés en la expresión corporal, la promoción de estilos de vida
      saludable y la práctica de la actividad física, así como en aprender sobre
      las ciencias del deporte, el diseño de programas de entrenamiento y los
      efectos del ejercicio físico en la salud.
    </p>
    <p className='text-center'>
      ¿Qué asignaturas de profundización se relacionan con esta disciplina y te
      podrían atraer más?
    </p>
    <p className='text-center'>
      <strong>
        {cursos
          ? makeCoursesString(cursos)
          : 'Ciencias de Ejercicio Físico y Deportivo, Expresión Corporal, Promoción de Estilos de Vida Activos y Saludables'}
        .
      </strong>
    </p>
  </>
);

const getFilteredAreas = ({ disciplines, electivos }) => {
  const filteredData = disciplines.filter(dp => {
    const currElectivo = electivos.find(e => e.id === dp.area);
    return currElectivo && currElectivo.available;
  });
  return filteredData;
};

const getFilteredData = ({ disciplines, electivos }) => {
  const allDisciplines = electivos.map(dp => dp.disciplinas).flat();
  const filteredAreas = getFilteredAreas({ disciplines, electivos });
  const filteredData = filteredAreas.filter(dp => {
    const curr = allDisciplines.find(e => e.id === dp.dimension);
    return curr && curr.available;
  });
  return filteredData;
};

const TopDisciplinesPage = ({ user, background, number, electivos }) => {
  const allDisciplines = electivos.map(dp => dp.disciplinas).flat();
  // console.log({ allDisciplines });
  const getCoursesFromDiscipline = id => {
    const discipline = allDisciplines.find(d => d.id === id);
    return discipline && discipline?.customCourses;
  };
  // console.log({ sorted: user.sortedDisp });
  const filteredSorted = getFilteredData({
    disciplines: user.sortedDisp,
    electivos
  });
  console.log({ filteredSorted });
  // const TOP_1 = cleanDisciplinesName(user.sortedDisp[0].field);
  const TOP_1 = filteredSorted[0].dimension;
  const TOP_2 = filteredSorted[1].dimension;
  const TOP_3 = filteredSorted[2].dimension;
  // console.log({ TOP_1, TOP_2, TOP_3 });
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h3>{`3.2.1. ${getAreaFullName(TOP_1)}`}</h3>
          {TOP_1 === 'F' && (
            <Filosofía cursos={getCoursesFromDiscipline('F')} />
          )}
          {TOP_1 === 'HGC' && (
            <HGCSOC cursos={getCoursesFromDiscipline('HGC')} />
          )}
          {TOP_1 === 'LL' && (
            <LenguaLiteratura cursos={getCoursesFromDiscipline('LL')} />
          )}
          {TOP_1 === 'CBS' && (
            <CienciasBio cursos={getCoursesFromDiscipline('CBS')} />
          )}
          {TOP_1 === 'CD' && (
            <CienciasBasicas cursos={getCoursesFromDiscipline('CD')} />
          )}
          {TOP_1 === 'M' && (
            <Matematicas cursos={getCoursesFromDiscipline('M')} />
          )}
          {TOP_1 === 'AI' && (
            <ArtesInterpretativas cursos={getCoursesFromDiscipline('AI')} />
          )}
          {TOP_1 === 'AV' && (
            <ArtesVisuales cursos={getCoursesFromDiscipline('AV')} />
          )}
          {TOP_1 === 'D' && <Deportes cursos={getCoursesFromDiscipline('D')} />}

          <h3>{`3.2.2. ${getAreaFullName(TOP_2)}`}</h3>
          {TOP_2 === 'F' && (
            <Filosofía cursos={getCoursesFromDiscipline('F')} />
          )}
          {TOP_2 === 'HGC' && (
            <HGCSOC cursos={getCoursesFromDiscipline('HGC')} />
          )}
          {TOP_2 === 'LL' && (
            <LenguaLiteratura cursos={getCoursesFromDiscipline('LL')} />
          )}
          {TOP_2 === 'CBS' && (
            <CienciasBio cursos={getCoursesFromDiscipline('CBS')} />
          )}
          {TOP_2 === 'CD' && (
            <CienciasBasicas cursos={getCoursesFromDiscipline('CD')} />
          )}
          {TOP_2 === 'M' && (
            <Matematicas cursos={getCoursesFromDiscipline('M')} />
          )}
          {TOP_2 === 'AI' && (
            <ArtesInterpretativas cursos={getCoursesFromDiscipline('AI')} />
          )}
          {TOP_2 === 'AV' && (
            <ArtesVisuales cursos={getCoursesFromDiscipline('AV')} />
          )}
          {TOP_2 === 'D' && <Deportes cursos={getCoursesFromDiscipline('D')} />}

          <h3>{`3.2.3. ${getAreaFullName(TOP_3)}`}</h3>
          {TOP_3 === 'F' && (
            <Filosofía cursos={getCoursesFromDiscipline('F')} />
          )}
          {TOP_3 === 'HGC' && (
            <HGCSOC cursos={getCoursesFromDiscipline('HGC')} />
          )}
          {TOP_3 === 'LL' && (
            <LenguaLiteratura cursos={getCoursesFromDiscipline('LL')} />
          )}
          {TOP_3 === 'CBS' && (
            <CienciasBio cursos={getCoursesFromDiscipline('CBS')} />
          )}
          {TOP_3 === 'CD' && (
            <CienciasBasicas cursos={getCoursesFromDiscipline('CD')} />
          )}
          {TOP_3 === 'M' && (
            <Matematicas cursos={getCoursesFromDiscipline('M')} />
          )}
          {TOP_3 === 'AI' && (
            <ArtesInterpretativas cursos={getCoursesFromDiscipline('AI')} />
          )}
          {TOP_3 === 'AV' && (
            <ArtesVisuales cursos={getCoursesFromDiscipline('AV')} />
          )}
          {TOP_3 === 'D' && <Deportes cursos={getCoursesFromDiscipline('D')} />}

          <br />
          <br />
          <br />
          <br />
          <div style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', top: -45, left: -25 }}>
              <img
                src={icono}
                alt='icono binoculares'
                style={{ width: 100, height: 'auto' }}
              />
            </div>
            <div className='edu-bubble-group bg-edu-red'>
              <p className='justified'>
                Cómo ves, ¡tienes varias opciones! Tal vez ya tienes claro las
                asignaturas que quieres elegir, o puede que aún tengas dudas, lo
                cual es normal. Para tomar una decisión más segura, te sugerimos
                averiguar más sobre los cursos que te interesan, de qué se
                tratan, cómo son las clases o evaluaciones. Puedes conversar con
                docentes sobre cómo los cursos se pueden relacionar con tus
                intereses vocacionales, y también con compañeros/as de cursos
                superiores que ya hayan tenido el curso que te interesa para
                conocer su experiencia.
              </p>
              <p className='justified'>
                <strong>
                  ¡Mientras más información tengas, con mayor claridad podrás
                  tomar una decisión!
                </strong>
              </p>
            </div>
          </div>
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default TopDisciplinesPage;
